// extracted by mini-css-extract-plugin
export default {"loading":"styles_loading__2st7E"};